import { render, staticRenderFns } from "./FatMale.vue?vue&type=template&id=7ec43338&scoped=true&"
import script from "./FatMale.vue?vue&type=script&lang=js&"
export * from "./FatMale.vue?vue&type=script&lang=js&"
import style0 from "./FatMale.vue?vue&type=style&index=0&id=7ec43338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec43338",
  null
  
)

export default component.exports